const styles = {
  descriptionSx: {
    color: "white",
    fontSize: 16,
    lineHeight: 1.8,
    textAlign: "justify",
    "& p": { marginBottom: "1.2em" },
    "& ul, & ol": { paddingLeft: "1.5em", marginBottom: "1em" },
    "& strong": { fontWeight: 600 },
    "& em": { fontStyle: "italic" },
    "& h2, & h3, & h4": { marginBottom: "0.5em", marginTop: "1em" },
    "& *": { color: "inherit" },
  },
};

export default styles;
